import axios from '../utils/axios';

export default function getSearchMailReport (adminId, params) {
    return axios.get(`/admin/${adminId}/search/mail-report`, { params });
}